// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 240 ? "c36f3faa" : chunkId) + "." + {"240":"0cb855395bd37158","482":"35784949f9d9c6fb","984":"7842c93c09926abf"}[chunkId] + ".js";
};